import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { NewPurchase } from '../components/Purchases/NewPurchase/NewPurchase';
import store from '../redux/store';
import { svTheme } from '../theme';

  const containerElementName = 'reactNewPurchase';

  @Component({
    selector: 'sv-new-purchase',
    template: `<div #${containerElementName}></div>`,
    // styleUrls: [''],
    encapsulation: ViewEncapsulation.None,
  })
  export class NewPurchaseWrapper implements OnChanges, OnDestroy, AfterViewInit {
    @ViewChild(containerElementName, { static: true }) containerRef!: ElementRef;

    @Output() public componentClick = new EventEmitter<void>();

    constructor() {
        this.handleDivClicked = this.handleDivClicked.bind(this);
    }

    public handleDivClicked() {
        if (this.componentClick) {
            this.componentClick.emit();
            this.render();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    ngAfterViewInit() {
        this.render();
    }

    ngOnDestroy() {
        ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
    }

    private render() {

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                <ConfigProvider locale={ptBR}>
                    <ThemeProvider theme={svTheme}>
                    <div>
                        <NewPurchase />
                    </div>
                    </ThemeProvider>
                </ConfigProvider>
                </Provider>
            </React.StrictMode>
            , this.containerRef.nativeElement);
    }
  }
